import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

const AdminLogin = () => {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin");
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-foreground/50 hover:text-foreground transition-colors mb-10">
          <ArrowLeft size={14} /> Back to site
        </a>
        <Logo size="lg" className="mb-3" />
        <p className="text-xs uppercase tracking-widest text-foreground/50 mb-10">Admin Console</p>

        <form onSubmit={submit} className="border border-foreground/15 p-8 md:p-10" data-testid="admin-login-form">
          <label className="block mb-8">
            <span className="text-xs uppercase tracking-widest text-foreground/50">Email</span>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="slip-input mt-2" placeholder="admin@stainless.in" />
          </label>
          <label className="block mb-8">
            <span className="text-xs uppercase tracking-widest text-foreground/50">Password</span>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="slip-input mt-2" placeholder="••••••••" />
          </label>
          {error && <p className="text-sm text-destructive mb-6" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-foreground text-background py-4 text-sm font-medium uppercase tracking-widest hover:bg-accent transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
